module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxCAYAAABznEEcAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACcSURBVGiB7dgxDoMwEAXRTZSD+WjcLDfLpHGfIl4YrP8kWpYRWEj7AKi7u3sEwPPqh1ghERaJsEiERSIsEmGRCItEWCTCojUCGMDonFHV/ybGvFrlc7LYImLpygY4+O29at6cSeveaUYdXfefM7J30tgion0X2/3Hbj/YZ8jBNkmERSIsEmGRCItEWCTCIhEWW0S8qqqAz9UP8o8vIKVoc9qN/iMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/add-box.png
// module id = cGuo
// module chunks = 1